module.exports = __webpack_public_path__ + "static/media/Lavender Brown 1.23f5d84b.jpg";